import { render } from "./ProjectsForm.vue?vue&type=template&id=10272a04&scoped=true"
import script from "./ProjectsForm.vue?vue&type=script&lang=js"
export * from "./ProjectsForm.vue?vue&type=script&lang=js"

import "./ProjectsForm.vue?vue&type=style&index=0&id=10272a04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10272a04"]])

export default __exports__